import React, { Component } from 'react';
import './App.css';
import Sidebar from './components/sidebar'
import Introduction from './components/introduction'
import About from './components/about'
import Timeline from './components/timeline'
import { Grid } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { Container } from '@material-ui/core';
import Navbar from './components/Navbar';
import TypeWriterEffect from './components/TypeWriterEffect';

// #0f0f0f	#141414	#171717 #1c1c1c	#212121	#242424 (black colors code)
class App extends Component {
  render() {


    // return (
    //   <Grid container direction="row" justify="flex-start" alignItems="flex-start"
    //     style={{ height: "100vh", backgroundColor: "#0f0f0f" }}>
    //     <Grid item xs={12} style={{ height: "20vh" }}>
    //       <Navbar />
    //     </Grid>
    //     <Grid container direction="row" justify="space-between" style={{ height: "70vh" }}>
    //       <Grid item xs={6}>
    //         <TypeWriterEffect />
    //         {/* src='url(images/vikashkumar.jpg)' */}
    //       </Grid>
    //       <Grid item xs={6}>
    //         <img src={`${process.env.PUBLIC_URL}/images/fs2.jpg`} width="600px" alt="Logo" />
    //       </Grid>
    //     </Grid>
    //     <Grid item xs={12} style={{ height: "10vh" }}>
    //       <Paper>
    //       </Paper>
    //     </Grid>
    //   </Grid>
    // )














    return (
      <div id="colorlib-page">
        <div id="container-wrap">
         	<Sidebar></Sidebar>
				<div id="colorlib-main">
					<Introduction></Introduction>
					<About></About>
					<Timeline></Timeline>
          	</div>
      	</div>
      </div>
    );
  }
}

export default App;
